import { List } from 'immutable'
import * as groupsActions from './actions'
import { Record } from '../transit'
import Group from './Group'
import User from '../users/User'

const State = Record({
  all: [],
  currentGroup: null,
  studentsWithoutGroup: [],
}, 'groups')

const groupsReducer = (state = new State(), action) => {
  switch (action.type) {
    case groupsActions.GROUP_LOAD_SUCCESS: {
      const newGroup = action.payload.data
      return state.set('currentGroup', new Group(newGroup))
    }
    case groupsActions.GROUP_ADD_SUCCESS: {
      const newGroup = action.payload.data
      const newAll = [...state.get('all'), newGroup]
      return state.set('currentGroup', new Group(newGroup))
                  .set('all', newAll)
    }
    case groupsActions.GROUPS_LOAD_SUCCESS: {
      return state.set('all', action.payload.data)
    }
    case groupsActions.GROUP_DELETE_SUCCESS: {
      const data = action.payload.data
      const newList = state.get('all').filter(g => g.id !== data.id)
      return state.set('all', newList)
    }
    case groupsActions.GROUPS_CLEAR: {
      return state.set('all', [])
    }
    case groupsActions.STUDENTS_WITHOUT_GROUP_LOAD_SUCCESS: {
      const newList = action.payload.data
      return state.set('studentsWithoutGroup', newList)
    }
    case groupsActions.GROUP_CLEAR: {
      return state.set('currentGroup', null)
    }
    default: {
      return state
    }
  }
}

export default groupsReducer



// WEBPACK FOOTER //
// ./src/common/groups/reducer.js